import nftsApi from "@/api/nfts/client";
import { OrderNftsBy } from "@/api/nfts/types";
import { OrderDirection } from "@/api/types";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants";
import { useWeb3State } from "@/web3/context";
import { useInfiniteQuery } from "@tanstack/react-query";
import { flatten } from "lodash";
import { useMemo } from "react";

export interface Props {
  order?: OrderNftsBy;
  collectionId: string;
  orderDirection?: OrderDirection;
}

const useCollectionInfiniteNfts = ({
  collectionId,
  order,
  orderDirection,
}: Props) => {
  const { network } = useWeb3State();
  const { data, hasNextPage, fetchNextPage } = useInfiniteQuery(
    ["collection-nfts", network, collectionId, order, orderDirection],
    async ({ pageParam = 0 }) => {
      return await nftsApi.getNftsForCollection(
        collectionId,
        pageParam * DEFAULT_PAGE_SIZE,
        DEFAULT_PAGE_SIZE,
        order,
        orderDirection,
      );
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.length < DEFAULT_PAGE_SIZE) {
          return undefined;
        }
        return allPages.length;
      },
    },
  );

  const nfts = useMemo(() => {
    return data ? flatten(data.pages) : [];
  }, [data]);

  return { nfts, hasNextPage, fetchNextPage };
};

export default useCollectionInfiniteNfts;
